import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useRunRequest } from '@/hooks';
import { path } from '@/pages/AdverseAction/constants';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { FCRAWorkerAdverse } from '@/types/turn-api';
import { COMBINED_REASONS_KEY } from './constants';
import { AdverseEditNoteProps } from '../types';

const useController = ({ toggleEditNote }: AdverseEditNoteProps) => {
  const { getValues, handleSubmit, setValue, watch } = useFormContext();
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const reasons = watch(path('adverse.specific_reasons'));

  useEffect(() => {
    if (reasons?.length) {
      const combined = reasons.map((r: FCRAWorkerAdverse.AdverseReason) => r.reason).join('\n');
      setValue(COMBINED_REASONS_KEY, combined);
    }
  }, [reasons, setValue]);

  const handleClose = () => toggleEditNote();

  const handleSave = async () => {
    const reasons = getValues(COMBINED_REASONS_KEY);

    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkersAdverse,
      params: {
        id: workerId,
        target: TurnTargetsEnum.Note,
        data: { reasons },
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error saving note' },
        onSuccess: { message: 'Note saved correctly' },
      },
    });

    handleClose();
  };

  return {
    handleClose,
    handleSave: handleSubmit(handleSave),
    reasons,
  };
};

export default useController;
